import React, { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import { navigate } from 'gatsby';
import appConfig from '../../../../../../app-config';
import { Body, Title1 } from '../../../../../components/Typography';
import { useDispatch } from 'react-redux';
import {
  displayTransferBalanceModal,
  setLoyaltyRegistrationModalOpen,
} from '../../../loyaltyActions';
import QRCode from 'react-qr-code';
import { Dialog, Popover } from '@material-ui/core';
import { FlatButton, PrimaryButton } from '../../../../../components/Buttons';
import { displayReloadGiftCard } from '../../../../GiftCard/giftCardActions';
import GiftCardContainer from '../../../../GiftCard/giftCardContainer';

const loyaltyTheme = appConfig.loyaltyTheme || {
  contentBackground: '',
  rewardText: '',
  rewardTextColor: '',
  nextOfferColor: '',
  yourBalanceText: '',
  yourBalanceColor: '',
  balanceText: { singular: '', plural: '' },
  balanceColor: '',
  allRewardsUnlockedTitleText: '',
  allRewardsUnlockedContentText: '',
  progressUnfillColor: '',
  progressFillColor: '',
  brandLogo: '',
};

const LayoutWrapper = styled.div`
  background-image: url(${loyaltyTheme.contentBackgroundImage});
  background-size: cover;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 5px 16px 0 rgba(66, 59, 112, 0.32);
  height: ${(props) => (props.layoutStyle === 'offer' ? '293px' : '209px')};
  width: ${(props) => (props.layoutStyle === 'offer' ? '100%' : '350px')};
  @media (min-width: 1551px) {
    height: ${(props) => (props.layoutStyle === 'offer' ? '293px' : '289px')};
    width: ${(props) => (props.layoutStyle === 'offer' ? '100%' : '450px')};
  }

  @media (max-width: 360px) {
    width: ${(props) => (props.layoutStyle === 'offer' ? '100%' : '320px')};
  }
`;

const RegisteredCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 15px;
  width: 450px;
  max-width: 450px;
  @media (max-width: 550px) {
    width: 360px;
  }
`;
const LayoutWrapperNotRegistered = styled.div`
  background-color: #000;
  background-size: cover;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 5px 16px 0 rgba(66, 59, 112, 0.32);

  height: ${(props) => (props.layoutStyle === 'offer' ? '293px' : '209px')};
  width: ${(props) => (props.layoutStyle === 'offer' ? '100%' : '350px')};
  max-width: 450px;
  @media (min-width: 1551px) {
    height: ${(props) => (props.layoutStyle === 'offer' ? '293px' : '289px')};
    width: ${(props) => (props.layoutStyle === 'offer' ? '100%' : '450px')};
  }

  @media (max-width: 360px) {
    width: ${(props) => (props.layoutStyle === 'offer' ? '100%' : '320px')};
  }
`;

const BalanceWrapper = styled.div`
  position: absolute;
  left: 25px;
  top: 35px;
  @media (max-width: 1551px) {
    left: 25px;
    top: 25px;
  }
`;
const Balance = styled(Title1)`
  color: #fff;
  font-weight: 600;
  @media (max-width: 1551px) {
    left: 10px;
    top: 10px;
    font-size: 18px;
  }
`;

const PopoverTextWrapper = styled.div`
  width: 350px;
  padding: 20px;
  border-radius: 15px;
`;
const PopoverTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 15px;
`;
const PopoverMessage = styled.div`
  margin-bottom: 15px;
`;

const ConfirmButton = styled(PrimaryButton)`
  padding: 19px 16px 19px 24px;
  font-size: 19px;
  font-weight: 600;
  text-transform: uppercase;
  width: 100%;
  &:hover {
    transition: all 0.25s ease;
  }
`;

const TopRightLogo = styled.div`
  position: absolute;
  right: 25px;
  top: 25px;
  width: 100px;
  height: 100px;
  cursor: pointer;
  z-index: 2;
  border-radius: 5px;
  border: 2px solid #fff;
  padding: 2px;
  @media (max-width: 1551px) {
    width: 80px;
    height: 80px;
  }
`;

const CenterLogo = styled.div`
  position: absolute;
  top: ${(props) => (props.isRegistered ? '45%' : '35%')};
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${(props) => (props.isRegistered ? '130px' : '200px')};
  @media (max-width: 1551px) {
    width: ${(props) => (props.isRegistered ? '140px' : '170px')};
  }
  @media (max-width: 750px) {
    width: ${(props) => (props.isRegistered ? '120px' : '140px')};
  }
`;

const NextRewardWrapper = styled.div`
  background: ${(props) => props.theme.primaryColor};
  display: ${(props) => (props.isRegistered ? 'grid' : 'flex')};
  grid-template-columns: 1fr 1fr;
  border-radius: 9px;
  padding: 15px 10px;
  grid-gap: 10px;
  max-height: 90px;
  position: absolute;
  bottom: 15px;
  left: 15px;
  right: 15px;
  justify-content: center;
  @media (max-width: 1551px) {
    max-height: 70px;
  }
`;

const RewardWrapper = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
`;

const RewardValue = styled.div`
  font-weight: 600;
  font-size: 26px;
  text-align: center;
  cursor: ${(props) => (!props.isRegistered ? 'default' : 'pointer')};
  @media (max-width: 1551px) {
    font-size: 16px;
  }
`;

const RewardTitle = styled.div`
  font-size: 20px;
  text-align: center;
  @media (max-width: 1551px) {
    font-size: 16px;
  }
`;

const QRCodeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  flex-direction: column;
`;
const BalanceBreakdown = styled.div`
  width: 300px;
  background-color: #fff;
`;
const ButtonRowWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  align-items: center;
`;
const QRCodeModalTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin: 20px 0 10px 0;
  margin-top: 10px;
  text-align: center;
`;
const QRCodeTitle = styled.div`
  font-size: 18px;
  font-weight: 400;
  margin: 20px 0 10px 0;
  text-align: center;
`;
const QRCodeNumber = styled.div`
  font-size: 22px;
  margin-bottom: 20px;
  font-weight: 600;
  margin-top: 10px;
  text-align: center;
`;
const LoyaltyNumberWrapper = styled.div`
  position: absolute;
  bottom: 105px;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  color: #fff;
  width: 100%;
  @media (max-width: 1551px) {
    bottom: 83px;
  }
`;

const LinkCardButton = styled(PrimaryButton)`
  padding: 0 5px;
  font-size: 19px;
  font-weight: 600;
  text-transform: uppercase;
  &:hover {
    transition: all 0.25s ease;
  }
  @media (max-width: 750px) {
    font-size: 14px;
  }
`;

const NewCardButton = styled(FlatButton)`
  padding: 0 16px;
  font-size: 19px;
  font-weight: 600;
  text-transform: uppercase;
  border: 1px solid #000;
  border-radius: 5px;
  width: 100%;
  height: 48px;
  color: ${(props) => props.theme.primaryColor};
  border-color: ${(props) => props.theme.primaryColor};
  &:hover {
    transition: all 0.25s ease;
  }
  @media (max-width: 750px) {
    font-size: 14px;
  }
`;
const QRCodeFullScreen = ({ isOpen, setIsOpen, qrCodeValue }) => {
  return (
    <Dialog
      id='Auth-AuthContainer-Dialog'
      aria-labelledby='payment-methods'
      aria-describedby='payment-methods'
      open={isOpen}
      onBackdropClick={() => setIsOpen(false)}
      fullWidth='sm'
      // fullScreen={typeof window !== 'undefined' && window.innerWidth < 786}
      PaperProps={{ style: { zIndex: 1000, borderRadius: 20 } }}
      scroll='body'
    >
      <QRCodeWrapper>
        <QRCodeModalTitle>Scan for Burrito Boyz Rewards</QRCodeModalTitle>
        <QRCode
          style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
          value={qrCodeValue?.replaceAll(' ', '')}
          level='M'
        />
        <QRCodeTitle>Your Burrito Boyz Rewards Number</QRCodeTitle>
        <QRCodeNumber>{qrCodeValue}</QRCodeNumber>
      </QRCodeWrapper>
    </Dialog>
  );
};

const BurritoLoyaltyCard = (props) => {
  const dispatch = useDispatch();
  const { current_loyalty_balance, gift_card_balance, status, loyalty_number } =
    props?.loyalty?.loyalty_details?.details?.data || {};

  const [isOpen, setIsOpen] = useState(false);
  const isRegistered = status === 'REGISTERED';
  const balanceText = useMemo(() => {
    if (current_loyalty_balance >= 0 && gift_card_balance >= 0) {
      return `$${(current_loyalty_balance + gift_card_balance).toFixed(2)}`;
    }
    return '';
  }, [current_loyalty_balance, gift_card_balance]);
  const handleClick = useCallback(() => {
    if (isRegistered) {
      navigate('/loyalty');
    } else {
      dispatch(setLoyaltyRegistrationModalOpen(true));
    }
  }, [isRegistered]);

  const threshold = props.loyalty?.loyalty_details?.details?.data?.program_threshold.toFixed(
    2
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleOpenBreakdown = useCallback((event) => {
    setAnchorEl(event?.currentTarget || null);
  }, []);
  return (
    <>
      {isRegistered ? (
        <RegisteredCardWrapper>
          <LayoutWrapper layoutStyle={props.layoutStyle} onClick={handleClick}>
            <BalanceWrapper>
              <Body style={{ color: '#fff' }}>
                Your Balance:{' '}
                <i
                  className='fal fa-info-circle'
                  style={{ paddingBottom: '0.25em', marginLeft: '0.25em' }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleOpenBreakdown(e);
                  }}
                />
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={() => handleOpenBreakdown()}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                >
                  <PopoverTextWrapper>
                    <PopoverTitle>Balance Breakdown</PopoverTitle>
                    <PopoverMessage>
                      {`Your total balance includes both your Gift Card balance
                  and Loyalty balance. Please note, Loyalty balance can only
                  be used once it reaches a minimum of $${threshold}. Until then,
                  continue using your Gift Card balance and accumulate more
                  loyalty funds for future purchases.`}
                    </PopoverMessage>
                    <ConfirmButton onClick={() => handleOpenBreakdown()}>
                      Ok
                    </ConfirmButton>
                  </PopoverTextWrapper>
                  <BalanceBreakdown></BalanceBreakdown>
                </Popover>
              </Body>
              <Balance>{balanceText}</Balance>
            </BalanceWrapper>
            <TopRightLogo>
              <QRCode
                style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                value={loyalty_number?.replaceAll(' ', '')}
                level='M'
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen(true);
                }}
              />
            </TopRightLogo>
            <CenterLogo isRegistered={isRegistered}>
              <img src={loyaltyTheme.brandLogo} width='100%' height='100%' />
            </CenterLogo>
            {props.isForLoyaltyPage && (
              <LoyaltyNumberWrapper>{loyalty_number}</LoyaltyNumberWrapper>
            )}
            <NextRewardWrapper isRegistered={isRegistered}>
              <RewardWrapper isRegistered={isRegistered}>
                <RewardValue>{`$${gift_card_balance.toFixed(2)}`}</RewardValue>
                <RewardTitle>Gift Card Balance</RewardTitle>
              </RewardWrapper>
              <RewardWrapper isRegistered={isRegistered}>
                <RewardValue>{`$${current_loyalty_balance.toFixed(
                  2
                )}`}</RewardValue>
                <RewardTitle>Loyalty Balance</RewardTitle>
              </RewardWrapper>
            </NextRewardWrapper>
          </LayoutWrapper>
          {props.isForLoyaltyPage && (
            <ButtonRowWrapper>
              <LinkCardButton
                id='ExistingGiftCard-AddGiftCard'
                type='submit'
                onClick={() => {
                  dispatch(displayReloadGiftCard());
                }}
                buttonWidth='150px'
              >
                RELOAD GIFT CARD
              </LinkCardButton>
              <NewCardButton
                id='ExistingGiftCard-AddGiftCard'
                type='submit'
                onClick={() => {
                  dispatch(displayTransferBalanceModal(true));
                }}
              >
                TRANSFER BALANCE
              </NewCardButton>
            </ButtonRowWrapper>
          )}
        </RegisteredCardWrapper>
      ) : (
        <LayoutWrapperNotRegistered
          layoutStyle={props.layoutStyle}
          onClick={handleClick}
        >
          <CenterLogo>
            <img src={loyaltyTheme.brandLogo} width='100%' height='100%' />
          </CenterLogo>
          <NextRewardWrapper>
            <RewardWrapper>
              <RewardTitle>Burrito Boyz Loyalty Program</RewardTitle>
              <RewardValue onClick={handleClick}>Join Now</RewardValue>
            </RewardWrapper>
          </NextRewardWrapper>
        </LayoutWrapperNotRegistered>
      )}
      <QRCodeFullScreen
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        qrCodeValue={loyalty_number}
      />
      <GiftCardContainer />
    </>
  );
};

export default BurritoLoyaltyCard;
